<svg
  [attr.viewBox]="viewBox"
  [attr.height]="height"
  [attr.width]="width"
  [style.height.px]="height"
  [style.width.px]="width"
  xmlns="http://www.w3.org/2000/svg"
  aria-label="Fraction"
>
  <line x1="0" y1="0" x2="0" y2="100%" [attr.stroke]="color" [attr.stroke-width]="strokeWidth" />
  <line
    x1="100%"
    y1="0"
    x2="100%"
    y2="100%"
    [attr.stroke]="color"
    [attr.stroke-width]="strokeWidth"
  />

  <g *ngIf="!useTextInput">
    <g *ngFor="let row of value; index as rowIndex">
      <text
        *ngFor="let number of row; index as valueIndex"
        [attr.y]="(100 * (rowIndex + 0.5)) / value.length + 3 + '%'"
        [attr.x]="(100 * (valueIndex + 0.5)) / row.length + '%'"
        dominant-baseline="middle"
        text-anchor="middle"
        [attr.fill]="color"
        [attr.font-size]="fontSize"
        [attr.font-family]="fontFamily"
        [attr.font-weight]="fontWeight"
      >
        {{ number }}
      </text>
    </g>
  </g>

  <svg x="0" y="24%" width="100%" height="48%">
    <foreignObject
      class="input-wrapper"
      *ngIf="useTextInput"
      x="0"
      y="0"
      width="100%"
      height="100%"
    >
      <!-- TODO: Не реализовано -->
      <body xmlns="http://www.w3.org/1999/xhtml">
        <input
          type="text"
          class="input"
          gameFocus
          msVirtualKeyboard
          [formControl]="valueControl"
          [style.font-size.px]="fontSize"
          [style.font-family]="fontFamily"
          [style.font-weight]="fontWeight"
          [style.color]="color"
          [readonly]="readonly"
        />
      </body>
    </foreignObject>
  </svg>
</svg>

<ng-content></ng-content>
